import { PathNames } from '../../constants/routingPath';

export const EXCLUDED_ROUTE_PROTECTION_PATHS: string[] = [
  PathNames.AUTH_GITHUB_CALLBACK,
  PathNames.AUTH_GOOGLE_CALLBACK,
  PathNames.AUTH_MAGIC_VERIFY,
  PathNames.ERROR,
  PathNames.FORGOT_PASSWORD,
  PathNames.LOGIN_VIA_SIGNUP,
  PathNames.RESET_PASSWORD,
  PathNames.SIGN_IN,
  PathNames.SIGN_UP,
  PathNames.SIGN_UP_SUCCESS,
];
